module.exports = __webpack_public_path__ + "static/media/bicycle.4d5061a7.svg";